import {
  CalendarOutlined,
  FundProjectionScreenOutlined,
  LineChartOutlined,
  AlertOutlined,
  AuditOutlined,
  CloudUploadOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DollarOutlined,
  SettingOutlined,
  ShoppingOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UserOutlined
} from '@ant-design/icons';
import { getSettingsTabs } from 'utils/settingsTabs';

function settingsNavItem() {
  return {
    id: 'settings',
    title: 'nav.settings',
    type: 'item',
    url: '/settings',
    icon: SettingOutlined
  };
}

function buildMenu(user) {
  const role = user?.role;
  const hasSettings = getSettingsTabs(role, user).length > 0;

  const startChildren = [
    {
      id: 'dashboard',
      title: 'nav.dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'calendar',
      title: 'nav.calendar',
      type: 'item',
      url: '/calendar',
      icon: CalendarOutlined
    },
    {
      id: 'profile',
      title: 'profile.myProfile',
      type: 'item',
      url: '/profile',
      icon: UserOutlined,
      breadcrumbs: false
    }
  ];

  if (hasSettings) {
    startChildren.push(settingsNavItem());
  }

  const start = {
    id: 'group-start',
    title: 'nav.start',
    type: 'group',
    children: startChildren
  };

  const clients = {
    id: 'group-clients',
    title: 'nav.clients',
    type: 'group',
    children: [{ id: 'clients', title: 'nav.clients', type: 'item', url: '/clients', icon: ContactsOutlined }]
  };

  const commercial = {
    id: 'group-commercial',
    title: 'nav.commercial',
    type: 'group',
    children: [
      { id: 'deals', title: 'nav.opportunities', type: 'item', url: '/deals', icon: FundProjectionScreenOutlined },
      { id: 'forecast', title: 'nav.forecast', type: 'item', url: '/insights/forecast', icon: LineChartOutlined },
      { id: 'products', title: 'nav.products', type: 'item', url: '/products', icon: ShoppingOutlined }
    ]
  };

  const billing = {
    id: 'group-billing',
    title: 'nav.billing',
    type: 'group',
    children: [
      { id: 'documents', title: 'nav.documents', type: 'item', url: '/documents', icon: DollarOutlined },
      { id: 'collections', title: 'nav.collections', type: 'item', url: '/collections', icon: AlertOutlined }
    ]
  };

  const purchases = {
    id: 'group-purchases',
    title: 'nav.purchases',
    type: 'group',
    children: [
      { id: 'suppliers', title: 'nav.suppliers', type: 'item', url: '/suppliers', icon: ShoppingOutlined },
      { id: 'received-documents', title: 'nav.receivedDocuments', type: 'item', url: '/received-documents', icon: DollarOutlined }
    ]
  };

  const operations = {
    id: 'group-operations',
    title: 'nav.operations',
    type: 'group',
    children: [
      { id: 'automation', title: 'nav.automation', type: 'item', url: '/automation', icon: ThunderboltOutlined },
      { id: 'import', title: 'nav.import', type: 'item', url: '/imports', icon: CloudUploadOutlined }
    ]
  };

  const company = {
    id: 'group-company',
    title: 'nav.company',
    type: 'group',
    children: [
      { id: 'users', title: 'nav.users', type: 'item', url: '/users', icon: TeamOutlined },
      { id: 'audit-log', title: 'nav.auditLog', type: 'item', url: '/audit-log', icon: AuditOutlined }
    ]
  };

  if (role === 'superadmin' || role === 'owner' || role === 'admin') {
    return { items: [start, clients, commercial, billing, purchases, operations, company] };
  }

  return { items: [start, clients, commercial, billing, purchases] };
}

export default buildMenu;
